import { Component, OnInit } from '@angular/core';
import { FaqCategory } from '../../../models/faqcategory.model';
import { Subscription } from 'rxjs';
import { FaqCategoryService } from '../../../services/faqcategory.service';
import { AdminService } from '../../admin.service';

declare var jQuery: any;
@Component({
  selector: 'app-faq-category-dashboard',
  templateUrl: './faq-category-dashboard.component.html',
  styleUrls: ['./faq-category-dashboard.component.css']
})
export class FaqCategoryDashboardComponent implements OnInit {
  loading = true;
  faqscategory: FaqCategory[] = [];
  subscription: Subscription;
  subscriptionDelete: Subscription;

  constructor(private faqCategoryService: FaqCategoryService, private adminService: AdminService) { }

  ngOnInit() {
    this.faqCategoryService.httpGetFaqsCategory();

    this.subscription = this.faqCategoryService.faqsCategoryChanged.subscribe(
      (faqscategory: FaqCategory[]) => {
        
        this.faqscategory = faqscategory;

        setTimeout(
          () => {
            this.loading = false;
            jQuery('table').DataTable({
              "oLanguage": { "sSearch": "", "sLengthMenu": "_MENU_" },
              "pageLength": 50,
              "retrieve": true
            });
    
            jQuery('input[type=search]').addClass('btn-search');
            jQuery('input[type=search]').attr('placeholder','Search');
            jQuery('select').addClass('select_datatable');
            jQuery('select').append('<option selected>Filter</option>');
          }, 1000
        );
        
      }
    );


  }

  onDelete(id: number) {
    this.faqCategoryService.httpDeleteFaq(id);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/help/faq-category-dashboard/faq-category-dashboard.component.ts